import { Component, ElementRef, OnInit, QueryList, ViewChildren } from '@angular/core';
import { StartupService } from '../services/startup.service';
import { StepService } from '../services/step.service';
import { ThreeDService } from '../services/three-d.service';

@Component({
  selector: 'app-configurator',
  templateUrl: './configurator.component.html',
  styleUrls: ['./configurator.component.scss'],
})
export class ConfiguratorComponent implements OnInit {
  sharedLinkVersion = true;
  hideUI = true;
  loading = true;
  @ViewChildren('hideforui') hiddenElements: QueryList<ElementRef>;

  constructor(
    private startupService: StartupService,
    private threeDService: ThreeDService,
    private stepService: StepService
  ) {
    this.stepService.loading$.subscribe(loading => (this.loading = loading));
  }

  ngOnInit() {
    this.threeDService.finishedBuilding$.subscribe(() => {
      Array.from(document.getElementsByClassName('hidden')).forEach((el: any) => {
        el.style.transition = 'opacity 1s 2s ease-in-out';
        el.style.opacity = '1';
        setTimeout(() => {
          el.style.visibility = 'unset';
        }, 3500);
      });
      this.loading = false;
    });
    this.startupService.sharedLinkConfiguration$.subscribe((data: false | string) => {
      if (data === false) {
        this.sharedLinkVersion = false;
        return;
      }
      this.sharedLinkVersion = true;
    });
  }
}
